import axios from 'axios';
import alt from 'flux/alt/alt.js';

class DataActions {
  
  constructor() {
    this.appUrl = 'http://admin.anderssons.ax';
  }

  // Method for getting data from the provided end point url
  api(endPoint) {
    return new Promise((resolve, reject) => {
      axios.get(endPoint, {
        // withCredentials: true,
      }).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  // Method for getting Pages data
  getPages(cb) {
    let payload = {}

    this.api(this.appUrl + '/exports/').then((v) => {
      payload = v

      let lang = 'sv'

      for (const l of navigator.languages) {
        if (v.languages.includes(l)) {
          lang = l
          break
        }
      }
      
      payload.lang = lang

      this.getSuccess(payload)
      cb(payload)
    }).catch((e) => {
      
    })

    return true;
  }

  // This returnes an object with Pages and Posts data together
  // The Alt Store will listen for this method to fire and will store the returned data
  getSuccess(payload) {
    return payload;
  }
}

export default alt.createActions(DataActions);


// WEBPACK FOOTER //
// ./src/scripts/flux/actions/DataActions.js